import { TFunction } from 'i18next'
import React, { createContext } from 'react'

type I18nProviderProps = {
  children: React.ReactNode
  t: TFunction
}

export const baseTFunction = ((key: string) => key) as TFunction 
export const I18nContext = createContext<TFunction>(baseTFunction)

export default function I18nProvider({ children, t }: I18nProviderProps) {
  return (
    <I18nContext.Provider value={t}>
      {children}
    </I18nContext.Provider>
  )
}
